import { useBack, useBackMultipart } from "../http";
import { EpiCompanyConfigDTO } from "../types/EpiCompanyConfigDTO";
import { EpiPanelDTO } from "../types/EpiPanelDTO";
import { EpiPanelDetailDTO } from "../types/EpiPanelDetailDTO";

export class EpiInspectionService {
	constructor() {}
	axiosInstance = useBack();
	axiosInstanceMultipart = useBackMultipart();

	async getCompanies() {
		try {
			const response = await this.axiosInstance.get<EpiCompanyConfigDTO[]>('/epi-inspections/config');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as empresas do módulo de inspeção de EPIs`, error);
			return undefined;
		}
	}

	async getPanel(companyId: number) {
		try {
			const response = await this.axiosInstance.get<EpiPanelDTO>(`/epi-inspections/panel/${companyId}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os indicadores do painel de conformidade`, error);
			return undefined;
		}
	}

	async getPanelDetail(companyId: number, type: string) {
		try {
			const response = await this.axiosInstance
				.get<EpiPanelDetailDTO[]>(`/epi-inspections/panel/${companyId}/details?type=${type}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter o detalhamento do painel`, error);
			return undefined;
		}
	}

	async addCompanyByCnpj(cnpj: string) {
		const response = await this.axiosInstance
			.post<EpiCompanyConfigDTO>('/epi-inspections/config', { cnpj });
		return { ...response };
	}

	async saveConfig(companyId: number, config: Partial<EpiCompanyConfigDTO>) {
		const response = await this.axiosInstance
			.put<EpiCompanyConfigDTO>(`/epi-inspections/config/${companyId}`, config);
		return { ...response };
	}

	async deleteConfig(companyId: number) {
		const response = await this.axiosInstance.delete(`/epi-inspections/config/${companyId}`);
		return { ...response };
	}

	async getLogo(companyId: number) {
		try {
			const response = await this.axiosInstance
				.get<Blob>(`/epi-inspections/config/${companyId}/logo`, { responseType: 'blob' });
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter a logo da empresa`, error);
			return undefined;
		}
	}

	async saveLogo(companyId: number, form: FormData) {
		const response = await this.axiosInstanceMultipart
			.put<EpiCompanyConfigDTO>(`/epi-inspections/config/${companyId}/logo`, form);
		return { ...response };
	}

	async deleteLogo(companyId: number) {
		const response = await this.axiosInstance
			.delete<EpiCompanyConfigDTO>(`/epi-inspections/config/${companyId}/logo`);
		return { ...response };
	}
}
